import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./Home"
import NotFound from "./NotFound";
import Pedido from "./Pedido";
import "../styles/index.css";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pedido" element={<Pedido />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
